import { Slider } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { getMinMaxForWave, replaceWave } from "../../utils/waves";

import { SlidingDot } from "./SlidingDot";
import { TIMEBAR } from "../../consts/sentryIds";
import { filter } from "lodash";
import { palette } from "../../theme/palette";
import { useRef, useEffect, useState } from "react";
import { withStyles } from "@mui/styles";
import { getValueLabelValue } from "../../utils/timeSlider";

const useStyles = makeStyles({
  sliderContainer: {
    width: "100%",
    display: "flex",
  },
  slider: {
    margin: "30px",
    flex: 1,
  },
  overlaySlider: {
    height: "8px",
    margin: "30px",
    position: "absolute",
    paddingTop: "13px",
    paddingBottom: "13px",
    pointerEvents: "none",
  },
});

const DPDSlider = withStyles({
  root: {
    color: "white",
    height: 8,
  },
  thumb: {
    height: 20,
    width: 20,
    color: palette.dpdRed,
    zIndex: 101,
    "&:focus, &:hover, &:active": {
      boxShadow: "inherit",
    },
  },
  markLabel: {
    color: "white",
  },
  valueLabel: {
    backgroundColor: palette.dpdRed,
  },
  track: {
    height: 8,
    borderRadius: 4,
    color: palette.dpdRed,
  },
  mark: {
    marginTop: 3,
  },
  rail: {
    height: 8,
    borderRadius: 4,
    paddingRight: "5px",
    color: "white",
  },
})(Slider);

export const SliderComponent = ({
  hideLabel,
  marks,
  min,
  max,
  onChange,
  onChangeCommitted,
  value,
  waves = [],
  duration,
  onWaveMove,
}) => {
  const styles = useStyles();
  const sliderRef = useRef();

  // eslint-disable-next-line no-unused-vars
  const [clientWidth, setClientWidth] = useState(0);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setClientWidth(sliderRef?.current?.clientWidth);
    });
  }, []);

  const myWaves = filter(waves, (wave) => wave.position !== undefined);

  const onDragEnd = (wave) => {
    const newWaves = replaceWave({ waves, wave });
    onWaveMove && onWaveMove(newWaves);
  };

  return (
    <div className={styles.sliderContainer}>
      <DPDSlider
        ref={sliderRef}
        valueLabelDisplay={hideLabel ? "off" : "on"}
        aria-labelledby="discrete-slider-custom"
        marks={marks}
        step={25}
        className={styles.slider}
        min={min}
        max={max}
        valueLabelFormat={getValueLabelValue}
        defaultValue={0}
        value={value}
        onChange={onChange}
        onChangeCommitted={onChangeCommitted}
        sentryId={TIMEBAR}
      />
      <div
        className={styles.overlaySlider}
        style={{ width: sliderRef?.current?.clientWidth }}
      >
        {myWaves.map((wave, index) => {
          if (wave.position === undefined) return null;
          const boundingClientRect =
            sliderRef?.current?.getBoundingClientRect();
          const minMax = getMinMaxForWave({
            waves: myWaves,
            index,
            duration,
          });
          return (
            <SlidingDot
              key={index}
              wave={wave}
              bbox={boundingClientRect}
              duration={duration}
              onDragEnd={onDragEnd}
              {...minMax}
            />
          );
        })}
      </div>
    </div>
  );
};
